import { AuthState } from '../../types';
import { MutationTree } from 'vuex';
import { AuthData } from '@/models/auth';
import { LoginData } from '@/models/login';
import { UserData } from '@/models/user';

const mutations: MutationTree<AuthState> = {
  authSuccess(state: AuthState, authData: AuthData): void {
    state.data = authData;
  },
  setLoginData(state: AuthState, { email, password }: LoginData): void {
    if (email) state.login.email = email;

    if (password) state.login.password = password;

    if (email == '' && password == '') {
      state.login = {
        email,
        password,
      };
    }
  },
  logout(state: AuthState): void {
    state.data = {
      accessToken: '',
      expiresIn: 0,
      tokenType: '',
      user: {
        businessType: '',
        email: '',
        uuid: '',
        name: '',
        organization: '',
        phone: '',
      },
    };
  },
  setUserData(state: AuthState, data: UserData): void {
    state.data.user = data;
  },
  setToken(state: AuthState, token: string): void {
    state.data.accessToken = token;
  },
  setNewPassword(state: AuthState, newPassword: string): void {
    state.changePassword.new = newPassword;
  },
  setConfirmNewPassword(state: AuthState, confirmNewPassword: string): void {
    state.changePassword.confirm = confirmNewPassword;
  },
};

export default mutations;
